//
//
//
//
//
//

import threeDiseasesBg from './images/threeDiseases.png';
export default {
  data(){
    return{
      threeDiseasesBg
    }
  }
}



// WEBPACK FOOTER //
// ./src/project/articleProject/threeDiseases.vue